import { COMMON_TEXT } from '@/helpers/common-text';
import { QUERY_STRING_STORE } from '@/helpers/constants';
import { format, isPast } from 'date-fns';
import { Form, Formik } from 'formik';
import { cloneDeep, isEqual } from 'lodash';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from 'src/components/CustomComponent/LoadingSpinner';
import { getConfigurationUrlWithParam } from 'src/helpers/utility';
import {
  fetchCalendarOverridesByTenantId,
  fetchTenantById,
} from './query-request';
import { createAuthenticatedApiClient } from 'src/helpers/api-client';
import { WorkflowsApi } from '@/openapi/apis/WorkflowsApi';
import Toaster from 'src/components/CustomComponent/Toaster';
import CustomDropdown from '@/components/CustomComponent/CustomDropdown/CustomDropdown';
import CustomCheckbox from '@/components/CustomComponent/CustomCheckbox/CustomCheckbox';
import SaveButton from 'src/components/CustomComponent/SaveButton/SaveButton';

@connect(state => ({
  tenantId: state.querystring?.['select-tenant']?.[0],
  querystring: state.querystring,
  sessionStore: state.session,
}))
class WorkingHourSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: false,
      initialFormValues: {
        workingHour: 0,
        workingMinute: 0,
        isMondayHoliday: false,
        isTuesdayHoliday: false,
        isWednesdayHoliday: false,
        isThursdayHoliday: false,
        isFridayHoliday: false,
        isSaturdayHoliday: false,
        isSundayHoliday: false,
        isNationalHoliday: false,
        holidayDateList: [],
        weekdayDateList: [],
      },
      pastHolidayDateList: [],
      pastWeekdayDateList: [],
    };
    this.originalFormValues = {};
    this.toastRef = React.createRef();
    this.holidayType = {
      WEEK_DAY: '平日',
      HOLIDAY: '休日',
    };
    this.holidayOptions = [
      { key: 'monday', name: '月曜日', index: 0, keyString: 'isMondayHoliday' },
      {
        key: 'tuesday',
        name: '火曜日',
        index: 1,
        keyString: 'isTuesdayHoliday',
      },
      {
        key: 'wednesday',
        name: '水曜日',
        index: 2,
        keyString: 'isWednesdayHoliday',
      },
      {
        key: 'thursday',
        name: '木曜日',
        index: 3,
        keyString: 'isThursdayHoliday',
      },
      { key: 'friday', name: '金曜日', index: 4, keyString: 'isFridayHoliday' },
      {
        key: 'saturday',
        name: '土曜日',
        index: 5,
        keyString: 'isSaturdayHoliday',
      },
      { key: 'sunday', name: '日曜日', index: 6, keyString: 'isSundayHoliday' },
      {
        key: 'national',
        name: '祝日',
        index: 7,
        keyString: 'isNationalHoliday',
      },
    ];

    // create hour options from 00 to 23
    this.hourOptions = () => {
      const hourOptions = [];
      for (let i = 0; i < 24; i++) {
        hourOptions.push({
          label: i < 10 ? `0${i}` : `${i}`,
          value: i,
        });
      }
      return hourOptions;
    };

    // create minute options from 00 to 59
    this.minuteOptions = () => {
      const minuteOptions = [];
      for (let i = 0; i < 60; i++) {
        minuteOptions.push({
          label: i < 10 ? `0${i}` : `${i}`,
          value: i,
        });
      }
      return minuteOptions;
    };
  }

  componentDidMount() {
    const { tenant } = this.state;
    if (tenant) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    if (isTenantChanged) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  goBackToConfigPage = () => {
    const { querystring } = this.props;
    window.location.href = getConfigurationUrlWithParam({ querystring });
  };

  renderSaveButton = () => {
    const { isUpdating } = this.state;
    return (
      <SaveButton
        type="submit"
        loading={isUpdating}
        form="working-hour-setting-form"
        label="保存"
        iconSrc="assets/img/save-setting-icon.svg"
        iconAlt="Save"
      />
    );
  };

  getCheckedHolidays = ({ holidays }) => {
    const result = {
      isMondayHoliday: false,
      isTuesdayHoliday: false,
      isWednesdayHoliday: false,
      isThursdayHoliday: false,
      isFridayHoliday: false,
      isSaturdayHoliday: false,
      isSundayHoliday: false,
      isNationalHoliday: false,
    };
    if (holidays && holidays.length > 0) {
      for (const holidayIndex of holidays) {
        const findIndex = this.holidayOptions.findIndex(
          item => item.index === holidayIndex
        );
        if (findIndex > -1) {
          // set first char is upper case
          result[this.holidayOptions[findIndex].keyString] = true;
        }
      }
    }
    return result;
  };

  getIndexHolidays = ({ formValues }) => {
    if (formValues) {
      const result = [];
      for (const holiday of this.holidayOptions) {
        if (formValues[holiday.keyString]) {
          result.push(holiday.index);
        }
      }
      return result;
    }
    return [];
  };

  getData = async () => {
    const { initialFormValues, tenant, isLoading, isUpdating } = this.state;

    // Prevent redundant API calls if already loading or updating
    if (isLoading || isUpdating) {
      return;
    }

    if (!tenant) {
      console.warn('No tenant selected, skipping data fetch');
      return;
    }

    this.setState({ isLoading: true });

    try {
      const tenantInfoList = await fetchTenantById({ tenantId: tenant });
      if (tenantInfoList && tenantInfoList.length > 0) {
        const tenantInfo = tenantInfoList[0];
        let { business_hour_begin, holidays, tenant_id } = tenantInfo;
        business_hour_begin = business_hour_begin.toString() || '00:00';
        const workingHourMin = business_hour_begin.split(':');
        const workingHour = +workingHourMin[0];
        const workingMinute = +workingHourMin[1];

        // parse holidays as array, if not parsed, set to empty array
        if (holidays) {
          holidays = JSON.parse(holidays);
        } else {
          holidays = [];
        }
        const checkedHoliday = this.getCheckedHolidays({ holidays });

        const calendarOverrides = await fetchCalendarOverridesByTenantId({
          tenantId: tenant_id,
        });
        const weekdayDateList = [];
        const holidayDateList = [];
        if (calendarOverrides && calendarOverrides.length > 0) {
          for (const calendarOverride of calendarOverrides) {
            const { is_holiday } = calendarOverride;
            if (is_holiday === this.holidayType.WEEK_DAY) {
              weekdayDateList.push(calendarOverride.date);
            } else if (is_holiday === this.holidayType.HOLIDAY) {
              holidayDateList.push(calendarOverride.date);
            }
          }
        }

        const formValues = {
          ...initialFormValues,
          workingHour: workingHour,
          workingMinute: workingMinute,
          ...checkedHoliday,
          weekdayDateList: weekdayDateList,
          holidayDateList: holidayDateList,
        };
        this.originalFormValues = cloneDeep(formValues);
        this.setState(
          {
            initialFormValues: formValues,
            isLoading: false,
          },
          () => {
            this.separatePastAndCurrentDates();
          }
        );
      } else {
        this.setState({ isLoading: false });
        console.warn('No tenant information found');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      this.setState({ isLoading: false }, () => {
        Toaster.error('Failed to load working hour settings');
      });
    }
  };

  getUpdateDataPayload = ({ formValues }) => {
    let payload = {
      values: [],
    };

    let { workingHour, workingMinute, holidayDateList, weekdayDateList } =
      formValues;

    // Combine current and past dates for the update
    const { pastHolidayDateList, pastWeekdayDateList } = this.state;
    const allHolidayDateList = [...holidayDateList, ...pastHolidayDateList];
    const allWeekdayDateList = [...weekdayDateList, ...pastWeekdayDateList];

    const object = {
      business_hour_begin: `${workingHour < 10 ? '0' : ''}${workingHour}:${workingMinute < 10 ? '0' : ''
        }${workingMinute}`,
      holidays: this.getIndexHolidays({ formValues }),
      holiday_exceptions: allHolidayDateList,
      weekday_exceptions: allWeekdayDateList,
    };
    payload.values.push(object);
    return payload;
  };

  updateBusinessHour = async ({ updatePayLoad }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);

      // Add timeout to prevent indefinite waiting
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timeout')), 30000)
      );

      const updatePromise = workflowsApi.updateSettingsBusinessHour({
        apiPostWorkflowRequest: {
          ...updatePayLoad,
          tenantId: this.props.tenantId,
        }
      });

      const updateRes = await Promise.race([updatePromise, timeoutPromise]);

      const { success } = updateRes;
      if (!success) {
        throw new Error('UPDATE SETTING ERROR: Server returned unsuccessful status');
      }
      return { isSuccess: true };
    } catch (error) {
      console.error('UPDATE SETTING ERROR', error);
      // Return more specific error information
      return {
        isSuccess: false,
        error: error.message || 'Unknown error occurred'
      };
    }
  };

  updateData = async ({ updatePayLoad }) => {
    this.setState({ isUpdating: true });
    const { isSuccess, error } = await this.updateBusinessHour({
      updatePayLoad,
    });

    if (isSuccess) {
      // Update originalFormValues with current form state to prevent dirty checking issues
      const { initialFormValues, pastHolidayDateList, pastWeekdayDateList } = this.state;
      this.originalFormValues = cloneDeep({
        ...initialFormValues,
        // Include combined dates for proper comparison
        holidayDateList: [...initialFormValues.holidayDateList, ...pastHolidayDateList],
        weekdayDateList: [...initialFormValues.weekdayDateList, ...pastWeekdayDateList],
      });

      this.setState({ isUpdating: false }, () => {
        Toaster.success(COMMON_TEXT.SAVED_SUCCESSFULLY);
        // Remove the unnecessary getData() call that causes long loading
        // The form already has the current data, no need to re-fetch from server
      });
    } else {
      this.setState({ isUpdating: false }, () => {
        // Show more specific error message if available
        const errorMessage = error ? `${COMMON_TEXT.SAVE_FAILED}: ${error}` : COMMON_TEXT.SAVE_FAILED;
        Toaster.error(errorMessage);
      });
    }
  };

  separatePastAndCurrentDates = () => {
    const { initialFormValues, pastHolidayDateList, pastWeekdayDateList } = this.state;
    const { holidayDateList, weekdayDateList } = initialFormValues;

    // Separate past and current/future dates
    const currentHolidayDateList = [];
    const newPastHolidayDateList = [];
    const currentWeekdayDateList = [];
    const newPastWeekdayDateList = [];

    holidayDateList.forEach(date => {
      if (isPast(new Date(date))) {
        newPastHolidayDateList.push(date);
      } else {
        currentHolidayDateList.push(date);
      }
    });

    weekdayDateList.forEach(date => {
      if (isPast(new Date(date))) {
        newPastWeekdayDateList.push(date);
      } else {
        currentWeekdayDateList.push(date);
      }
    });

    // Merge existing past dates with newly separated past dates (remove duplicates)
    const mergedPastHolidayDateList = [...new Set([...pastHolidayDateList, ...newPastHolidayDateList])];
    const mergedPastWeekdayDateList = [...new Set([...pastWeekdayDateList, ...newPastWeekdayDateList])];

    // Only update state if there are actual changes to prevent unnecessary re-renders
    const hasHolidayChanges =
      currentHolidayDateList.length !== holidayDateList.length ||
      mergedPastHolidayDateList.length !== pastHolidayDateList.length ||
      !isEqual(currentHolidayDateList.sort(), holidayDateList.sort()) ||
      !isEqual(mergedPastHolidayDateList.sort(), pastHolidayDateList.sort());

    const hasWeekdayChanges =
      currentWeekdayDateList.length !== weekdayDateList.length ||
      mergedPastWeekdayDateList.length !== pastWeekdayDateList.length ||
      !isEqual(currentWeekdayDateList.sort(), weekdayDateList.sort()) ||
      !isEqual(mergedPastWeekdayDateList.sort(), pastWeekdayDateList.sort());

    if (hasHolidayChanges || hasWeekdayChanges) {
      this.setState({
        initialFormValues: {
          ...initialFormValues,
          holidayDateList: currentHolidayDateList,
          weekdayDateList: currentWeekdayDateList,
        },
        pastHolidayDateList: mergedPastHolidayDateList,
        pastWeekdayDateList: mergedPastWeekdayDateList,
      });
    }
  };

  renderSettingContent() {
    const {
      isLoading,
      initialFormValues,
      pastHolidayDateList,
      pastWeekdayDateList,
    } = this.state;

    const handleSubmit = (values, { setSubmitting, errors }) => {
      if (!errors) {
        // Combine current form values with past dates for proper comparison
        const { pastHolidayDateList, pastWeekdayDateList } = this.state;
        const currentCompleteValues = {
          ...values,
          holidayDateList: [...values.holidayDateList, ...pastHolidayDateList],
          weekdayDateList: [...values.weekdayDateList, ...pastWeekdayDateList],
        };

        if (isEqual(currentCompleteValues, this.originalFormValues)) {
          setSubmitting(false);
          return;
        }
        const updatePayLoad = this.getUpdateDataPayload({
          formValues: values,
        });
        this.updateData({ updatePayLoad });
      } else {
        setSubmitting(false);
      }
    };

    const datePickerOnSelected = ({ e, fieldName, values }) => {
      let { value } = e;
      value = format(value, 'yyyy-MM-dd');
      const { holidayDateList, weekdayDateList } = values;

      if (fieldName === 'holidayDateList') {
        if (!holidayDateList.includes(value)) {
          const updatedHolidayDateList = [...holidayDateList, value];
          this.setState(
            {
              initialFormValues: {
                ...initialFormValues,
                holidayDateList: updatedHolidayDateList,
              },
            },
            () => {
              // Only separate dates if we actually added a new date
              this.separatePastAndCurrentDates();
            }
          );
        }
      } else if (fieldName === 'weekdayDateList') {
        if (!weekdayDateList.includes(value)) {
          const updatedWeekdayDateList = [...weekdayDateList, value];
          this.setState({
            initialFormValues: {
              ...initialFormValues,
              weekdayDateList: updatedWeekdayDateList,
            },
          }, () => {
            // Only separate dates if we actually added a new date
            this.separatePastAndCurrentDates();
          });
        }
      }
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <Formik
            initialValues={initialFormValues}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ values, handleChange, touched, errors, resetForm }) => (
              <Form id="working-hour-setting-form">
                <div className="main-row-container border-bottom">
                  <div className="left-title">
                    <span>1日の開始時間</span>
                  </div>
                  <div className="right-content">
                    <div className="input-text-field-container workinghour-group">
                      <div className="hour-container">
                        <CustomDropdown
                          id="workingHour"
                          value={values.workingHour}
                          options={this.hourOptions()}
                          onChange={e => handleChange(e)}
                        ></CustomDropdown>
                      </div>
                      <div className="ml-2 mr-2">
                        <b>:</b>
                      </div>
                      <div className="minute-container">
                        <CustomDropdown
                          id="workingMinute"
                          value={values.workingMinute}
                          options={this.minuteOptions()}
                          onChange={e => handleChange(e)}
                        ></CustomDropdown>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="main-row-container border-bottom">
                  <div className="left-title">
                    <span>休日とする日</span>
                  </div>
                  <div className="right-content">
                    <div className="input-text-field-container checkbox-group">
                      {this.holidayOptions.map(item => {
                        const { key, keyString } = item;
                        return (
                          <div key={key} >
                            <CustomCheckbox
                              label={item.name}
                              inputId={key}
                              name={keyString}
                              checked={values[keyString]}
                              onChange={(e) => {
                                handleChange({
                                  target: {
                                    name: keyString,
                                    value: e.target ? e.target.checked : !values[keyString]
                                  }
                                });
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="main-row-container align-start">
                  <div className="left-title">
                    <span>例外</span>
                  </div>
                  <div className="right-content">
                    <div className="row-container">
                      <div className="product-field">
                        <div className="is-header">
                          <span>休日とする日</span>
                        </div>
                        <Calendar
                          className="custom-date-picker figma-calendar-input"
                          dateFormat="yy年mm月dd日"
                          readOnlyInput
                          showIcon
                          icon={<img src="assets/img/calendar-icon.svg" alt="Calendar" />}
                          showButtonBar
                          selectionMode="single"
                          clearButtonClassName="hidden"
                          placeholder="日付を選択"
                          style={{ cursor: 'pointer' }}
                          onSelect={e => {
                            // Enhanced validation to ensure this is an actual date selection
                            if (e && e.value && e.value instanceof Date && e.originalEvent) {
                              // Check if the click target is actually a date cell (not navigation)
                              const target = e.originalEvent.target;
                              if (target && (
                                target.classList.contains('p-datepicker-day') ||
                                target.closest('.p-datepicker-day') ||
                                (target.tagName === 'SPAN' && target.closest('td'))
                              )) {
                                datePickerOnSelected({
                                  e,
                                  fieldName: 'holidayDateList',
                                  values,
                                });
                              }
                            }
                          }}
                        />
                        <div className="daylist-container bordered">
                          {!values.holidayDateList ||
                            values.holidayDateList.length === 0 ? (
                            <>
                              <div className="day-item no-data-container">
                                {COMMON_TEXT.NO_DATA}
                              </div>
                            </>
                          ) : (
                            <>
                              {values.holidayDateList
                                .sort()
                                .map((item, index) => {
                                  return (
                                    <div
                                      key={`holiday-date-${index}`}
                                      className="day-item"
                                    >
                                      <div className="day-value">{item}</div>
                                      <div>
                                        <Button
                                          type="button"
                                          text
                                          severity="danger"
                                          className="icon-only-delete-button"
                                          onClick={e => {
                                            const { holidayDateList } = values;
                                            const updatedHolidayDateList = [...holidayDateList];
                                            updatedHolidayDateList.splice(index, 1);
                                            this.setState({
                                              initialFormValues: {
                                                ...initialFormValues,
                                                holidayDateList: updatedHolidayDateList,
                                              },
                                            }, () => {
                                              this.separatePastAndCurrentDates();
                                            });
                                          }}
                                        >
                                          <span className="delete-icon">
                                            <img src="assets/img/trash-icon.svg" alt="Delete" />
                                          </span>
                                        </Button>
                                      </div>
                                    </div>
                                  );
                                })}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="key-field">
                        <div className="is-header">
                          <span>平日とする日</span>
                        </div>
                        <Calendar
                          className="custom-date-picker figma-calendar-input"
                          dateFormat="yy年mm月dd日"
                          readOnlyInput
                          showIcon
                          icon={<img src="assets/img/calendar-icon.svg" alt="Calendar" />}
                          showButtonBar
                          selectionMode="single"
                          clearButtonClassName="hidden"
                          placeholder="日付を選択"
                          onSelect={e => {
                            // Enhanced validation to ensure this is an actual date selection
                            if (e && e.value && e.value instanceof Date && e.originalEvent) {
                              // Check if the click target is actually a date cell (not navigation)
                              const target = e.originalEvent.target;
                              if (target && (
                                target.classList.contains('p-datepicker-day') ||
                                target.closest('.p-datepicker-day') ||
                                (target.tagName === 'SPAN' && target.closest('td'))
                              )) {
                                datePickerOnSelected({
                                  e,
                                  fieldName: 'weekdayDateList',
                                  values,
                                });
                              }
                            }
                          }}
                        />
                        <div className="daylist-container bordered">
                          {!values.weekdayDateList ||
                            values.weekdayDateList.length === 0 ? (
                            <>
                              <div className="day-item no-data-container">
                                {COMMON_TEXT.NO_DATA}
                              </div>
                            </>
                          ) : (
                            <>
                              {values.weekdayDateList
                                .sort()
                                .map((item, index) => {
                                  return (
                                    <div
                                      key={`weekday-date-${index}`}
                                      className="day-item"
                                    >
                                      <div className="day-value">{item}</div>
                                      <div>
                                        <Button
                                          type="button"
                                          text
                                          severity="danger"
                                          className="icon-only-delete-button"
                                          onClick={e => {
                                            const { weekdayDateList } = values;
                                            const updatedWeekdayDateList = [...weekdayDateList];
                                            updatedWeekdayDateList.splice(index, 1);
                                            this.setState({
                                              initialFormValues: {
                                                ...initialFormValues,
                                                weekdayDateList: updatedWeekdayDateList,
                                              },
                                            }, () => {
                                              this.separatePastAndCurrentDates();
                                            });
                                          }}
                                        >
                                          <span className="delete-icon">
                                            <img src="assets/img/trash-icon.svg" alt="Delete" />
                                          </span>
                                        </Button>
                                      </div>
                                    </div>
                                  );
                                })}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="main-row-container">
                  <div className="left-title">
                    {/* <span>過去の休日とする日</span> */}
                  </div>
                  <div className="right-content">
                    <div className="row-container">
                      <div className="product-field">
                        <div className="is-header">
                          <span>過去の休日とする日</span>
                        </div>
                        <div className="daylist-container bordered past-dates">
                          {!pastHolidayDateList ||
                            pastHolidayDateList.length === 0 ? (
                            <>
                              <div className="day-item no-data-container">
                                {COMMON_TEXT.NO_DATA}
                              </div>
                            </>
                          ) : (
                            <>
                              {pastHolidayDateList
                                .sort()
                                .map((item, index) => {
                                  return (
                                    <div
                                      key={`past-holiday-date-${index}`}
                                      className="day-item"
                                    >
                                      <div className="day-value">{item}</div>
                                      <div>
                                        <Button
                                          type="button"
                                          text
                                          severity="danger"
                                          className="icon-only-delete-button"
                                          onClick={e => {
                                            const updatedPastHolidayDateList = [...pastHolidayDateList];
                                            updatedPastHolidayDateList.splice(index, 1);
                                            this.setState({
                                              pastHolidayDateList: updatedPastHolidayDateList,
                                            });
                                          }}
                                        >
                                          <span className="delete-icon">
                                            <img src="assets/img/trash-icon.svg" alt="Delete" />
                                          </span>
                                        </Button>
                                      </div>
                                    </div>
                                  );
                                })}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="key-field">
                        <div className="is-header">
                          <span>過去の平日とする日</span>
                        </div>
                        <div className="daylist-container bordered past-dates">
                          {!pastWeekdayDateList ||
                            pastWeekdayDateList.length === 0 ? (
                            <>
                              <div className="day-item no-data-container">
                                {COMMON_TEXT.NO_DATA}
                              </div>
                            </>
                          ) : (
                            <>
                              {pastWeekdayDateList
                                .sort()
                                .map((item, index) => {
                                  return (
                                    <div
                                      key={`past-weekday-date-${index}`}
                                      className="day-item"
                                    >
                                      <div className="day-value">{item}</div>
                                      <div>
                                        <Button
                                          type="button"
                                          text
                                          severity="danger"
                                          className="icon-only-delete-button"
                                          onClick={e => {
                                            const updatedPastWeekdayDateList = [...pastWeekdayDateList];
                                            updatedPastWeekdayDateList.splice(index, 1);
                                            this.setState({
                                              pastWeekdayDateList: updatedPastWeekdayDateList,
                                            });
                                          }}
                                        >
                                          <span className="delete-icon">
                                            <img src="assets/img/trash-icon.svg" alt="Delete" />
                                          </span>
                                        </Button>
                                      </div>
                                    </div>
                                  );
                                })}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </>
    );
  }

  render() {
    return (
      <>
        <Toast ref={this.toastRef} position="top-center" />
        <ConfirmDialog />
        <div className="config-container custom-config-container workinghour-setting-container custom-setting-config-container">
          <div className="config-title-container">
            <div className="text-left">
              <div className="title-text">
                {COMMON_TEXT.WORKING_HOUR_SETTING}
              </div>
            </div>
            <div className="grid grid-nogutter align-items-center justify-content-end">
              {this.renderSaveButton()}
            </div>
          </div>
          <div className="config-content">
            <div className="setting-content">{this.renderSettingContent()}</div>
          </div>
        </div>
      </>
    );
  }
}

WorkingHourSetting.propTypes = {};

export default WorkingHourSetting;
